import { Link } from "react-router-dom";
import { ArrowRight, Home } from "lucide-react";
import { Seo } from "@/components/layout/Seo";
import { NAV } from "@/config/site";

export default function NotFound() {
  return (
    <>
      <Seo title="Page introuvable — O'RIZON 360" description="La page demandée n'existe pas ou a été déplacée." noindex />
      <section className="bg-slate text-white grain min-h-[75vh] flex items-center relative overflow-hidden" data-testid="not-found-page">
        <span className="absolute -right-24 top-10 w-[520px] h-[520px] rounded-full border-[3px] border-copper/25" aria-hidden="true" />
        <div className="container-x relative z-10 py-24">
          <p className="eyebrow mb-6">Erreur 404</p>
          <h1 className="h-display !text-white text-6xl sm:text-8xl lg:text-9xl">Hors <span className="text-copper">chantier</span></h1>
          <p className="mt-6 max-w-xl text-white/75 text-lg leading-relaxed">Cette page n'existe pas ou a été déplacée. Reprenons depuis les fondations.</p>
          <div className="mt-10 flex flex-col sm:flex-row gap-3">
            <Link to="/" className="btn-primary" data-testid="not-found-home-button"><Home size={18} /> Retour à l'accueil</Link>
            <Link to="/contact" className="btn-ghost-light" data-testid="not-found-contact-button">Demander un devis <ArrowRight size={18} /></Link>
          </div>
          <ul className="mt-12 flex flex-wrap gap-x-6 gap-y-2 text-sm text-white/60">
            {NAV.map((n) => <li key={n.to}><Link to={n.to} className="hover:text-copper transition-colors">{n.label}</Link></li>)}
          </ul>
        </div>
      </section>
    </>
  );
}
